export enum HotelPermissions {
  ALL = "Travel:Hotels:*",
  READ = "Travel:Hotels:Read",
  WRITE = "Travel:Hotels:Write",
}

export function hasHotelAccess(userPermissions: string[]): boolean {
  return userPermissions.some((p) =>
    [HotelPermissions.READ, HotelPermissions.ALL, "*"].includes(p)
  );
}
